import { FunctionComponent } from 'react';

const Intro: FunctionComponent<RewindSlideProps> = (props) => {
  const { active } = props;

  return (
    <div className="flex flex-col items-center w-full">
      <h2 className="text-2xl lg:text-4xl w-full max-w-[550px] lg:max-w-[1100px] m-auto slide-in-from-right break-words">
        <span>It looks like you didn&apos;t watch much on SBS On Demand this year.</span>
      </h2>
      <p className="mt-[100px] lg:mt-[167px] slide-up delay-[600ms]">Start streaming now and check back next December for your results!</p>
      <a href="https://www.sbs.com.au/ondemand">
        <button
          type="button"
          className="sbs-button sbs-button-primary mt-8 sm:mt-16
          slide-down delay-[900ms]"
          tabIndex={active ? 0 : -1}
        >
          Visit Homepage
        </button>
      </a>
    </div>
  );
};

export default Intro;
